import { globalAxios } from "@/axios-path.js";
export default {
  namespaced: true,
  state: {
    withdraw_commission: {},
    deposit_commission: {},
    penalty: [],
  },
  mutations: {
    resetState(state) {
      state.withdraw_commission = {};
      state.deposit_commission = {};
      state.penalty = {};
    },
    getWithdrawCommission(state, data) {
      state.withdraw_commission = data;
    },
    getDepositCommission(state, data) {
      state.deposit_commission = data;
    },
    updateDepositCommission(state, data) {
      state.deposit_commission = data;
    },
    updateWithdrawCommission(state, data) {
      state.withdraw_commission = data;
    },
    getPenalty(state, data) {
      state.penalty = data;
    },
    updatePenalty(state, data) {
      state.penalty = data;
    },
  },
  actions: {
    async getWithdrawCommission({ commit }, province) {
      let url = `/api/v1/${province}/backoffice/getWithdrawalCommission`;
      try {
        let res = await globalAxios.get(url);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("getWithdrawCommission", res.data);
          return res.data;
        }
      } catch (error) {
        let error_res = { "wd_credit_commission_type": 1, "wd_credit_commission_amount": 0.0, "wd_credit_commission_max": 0.0, "wd_coin_commission_type": 1, "wd_coin_commission_amount": 0.0, "wd_coin_commission_max": 0.0 };
        commit("getWithdrawCommission", error_res);
        return "error";
      }
    },
    async getDepositCommission({ commit }, province) {
      let url = `/api/v1/${province}/backoffice/getTopupCommission`;
      try {
        let res = await globalAxios.get(url);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("getDepositCommission", res.data);
          return res.data;
        }
      } catch (error) {
        let error_res = { "dp_credit_commission_type": 1, "dp_credit_commission_amount": 0.0, "dp_credit_commission_max": 0.0, "dp_coin_commission_type": 1, "dp_coin_commission_amount": 0.0, "dp_coin_commission_max": 0.0 };
        commit("getDepositCommission", error_res);
        return "error";
      }
    },
    async updateWithdrawCommission({ commit }, { payload, province }) {
      let url = `/api/v1/${province}/backoffice/updateWithdrawalCommission`;
      try {
        let res = await globalAxios.put(url, payload.body);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("updateWithdrawCommission", payload.data_save);
          return true;
        }
      } catch (error) {
        return false;
      }
    },
    async updateDepositCommission({ commit }, { payload, province }) {
      let url = `/api/v1/${province}/backoffice/updateTopupCommission`;
      try {
        let res = await globalAxios.put(url, payload.body);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("updateDepositCommission", payload.data_save);
          return true;
        }
      } catch (error) {
        return false;
      }
    },
    async getPenalty({ commit }, province) {
      let url = `/api/v1/${province}/Office/getPenalty`;
      try {
        let res = await globalAxios.get(url);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("getPenalty", res.data);
          return res.data;
        }
      } catch (error) {
        commit("getPenalty", []);
        return false;
      }
    },
    async updatePenalty({ commit }, { payload, province }) {
      let url = `/api/v1/${province}/Office/updatePenalty`;
      try {
        let res = await globalAxios.put(url, payload.body);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("updatePenalty", payload.data_save);
          return true;
        }
      } catch (error) {
        return false;
      }
    },
  }
};
